var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2354 27.1324C44.2354 36.344 36.7668 43.8126 27.5552 43.8126C18.3436 43.8126 10.875 36.344 10.875 27.1324C10.875 17.9207 18.3436 10.4521 27.5552 10.4521C36.7668 10.4521 44.2354 17.9207 44.2354 27.1324Z",
    fill: "#DDF9D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4379 20.4602L24.3215 29.882L20.5581 26.0081L18.6582 27.9693L24.3242 33.8044L35.3384 22.4214L33.4379 20.4602Z",
    fill: "#59D129"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.998 5.7124L26.998 1.00002",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.998 53.2646L26.998 48.5523",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.709 8.58203L40.0652 4.50099",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9316 49.7634L16.2878 45.6824",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2871 8.58203L13.9309 4.50099",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0645 49.7634L37.7083 45.6824",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5488 16.4224L49.6299 14.0662",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36719 40.1985L8.44823 37.8423",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44727 16.4224L4.36622 14.0662",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6289 40.1985L45.5479 37.8423",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.418 27.1323L53.1304 27.1323",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0.867188 27.1323L5.57957 27.1323",
    stroke: "#59D129",
    strokeWidth: 1.74215,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTick);
export default __webpack_public_path__ + "static/media/check-tick.63b9d70e89f7dfe42fe403c43f5815fb.svg";
export { ForwardRef as ReactComponent };